import React, {useRef,useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {NO_IMAGE} from '@/_constant/image-url-constants';
import { Button } from '@/_component/Common';
import classNames from 'classnames';

export default function KgSlider({mediaList}) {
  const [currentSlide, setCurrentSlide] = useState(4);
  const sliderRef = useRef(null);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
    sliderRef.current.slickGoTo(index);
  };

  const mainSliderSettings = {
    dots: true, // Show dots navigation
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true, // Show arrows navigation
    afterChange: (index) => handleSlideChange(index),
    appendDots: (dots) => (<ul id="dotsT" >{dots}</ul>),
    customPaging: (i) => (
      <div>
        <span
          style={{
            display: "inline-block",
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            background: "#bbb",
            margin: "0 5px",
          }}
        ></span>
      </div>
    ),
  };

  return (
    <div className={classNames('position-relative', {'mb-4': mediaList?.length > 1, "mb-3": mediaList?.length <= 1})}>
      <Slider {...mainSliderSettings} ref={sliderRef}>
        {mediaList?.map((item, i) => {
          let vId;
          if (item.mediaType === "YOUTUBE_VIDEO") {
            let youtubeUrl = item.url;
            let url = new URL(youtubeUrl);
            vId = url.searchParams.get("v");
          }
          return (
            <div key={i}>
              <div className="slickChild">
                
                {item.mediaType === "IMAGE" && <img src={!!item.url?item.url:NO_IMAGE} className='img-fluid rounded' style={{maxHeight: "27rem", width: "100%", objectFit: "contain"}} alt="Image" />}
                {item.mediaType === "VIDEO" && (
                  <video width="320" height="240" controls>
                    <source src={item.url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
                {item.mediaType === "YOUTUBE_VIDEO" && (
                  <iframe
                    width="100%"
                    height="430"
                    src={`https://www.youtube-nocookie.com/embed/${vId}`}
                    title="YouTube video player"
                    frameBorder="0"
                  ></iframe>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
      <div className="slider-controls d-flex justify-content-between position-absolute w-100 top-50">
        <Button noSpacing
          className="slick-arrow kg-bg-light"
          onClick={() => {sliderRef.current.slickPrev();}}
        >
          <i className="bi bi-chevron-left fs-3"></i>
        </Button>
        <Button noSpacing
          className="slick-arrow kg-bg-light"
          onClick={() => {sliderRef.current.slickNext();}}
        >
          <i className="bi bi-chevron-right fs-3"></i>
        </Button>
      </div>
      <div id="slickList" className="slickList" style={{display:"flex"}}>
        {mediaList?.map((item, i) => (
          
            <div aria-live="polite" className="slick-list" key={i} >
              <div className="slick-track"  role="listbox" >
                <div
                  data-info="IMAGE"
                  className={`slickChild slick-slide`} // ${i === currentSlide ?'slick-active':''}
                  data-slick-index="0"
                  aria-hidden="false"
                  style={{ width: "128px" }}
                  tabIndex="-1"
                  role="option"
                  aria-describedby="slick-slide30"
                >
                  <img
                    className='img-fluid'
                    style={{width: "5rem"}}
                    src={!!item.url?item.url:NO_IMAGE}
                    alt=""
                    onClick={() => {handleSlideChange(i)}}
                  />
                </div>
              </div>
            </div>
        ))}
      </div>
      
    </div>
  );
}
